import { render } from "./AsociarProfEsp.vue?vue&type=template&id=c4c67228"
import script from "./AsociarProfEsp.vue?vue&type=script&lang=js"
export * from "./AsociarProfEsp.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__